export const encodeParamObject = (payload) => {
    const params = payload || {};
    const newParams = {};
    Object.keys(params).forEach((key) => {
        newParams[key] = encodeURIComponent(params[key]);
    })
    return newParams;
}